export default "__VITE_ASSET__e0L6G6Sr__"